export enum DinneyResponseStatus {
    DELETED = "DELETED", DELETION_ERROR = "DELETION_ERROR"
}